// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    baseUrl: 'https://core-api-qa.thetitlegirl.com',
    adminPortalUrl: 'https://admin-qa.thetitlegirl.com',
    env: 'qa',
    features: {
        mfaLogin: false,
        bulkStatusUpdate: true,
        performanceDashboard: true,
        executiveDashboard: true,
        optionalFields: true,
        tradeIn: true,
        batch: true,
        printableDocs: true,
        reconciliation: true,
        tempTag: true
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
import {UserService} from '../app/user/service/users.service';
